export default () => {
  $(() => {
    let wrapper = $(".file_upload"),
      inp = wrapper.find("input"),
      btn = wrapper.find("button"),
      lbl = wrapper.find("div");
    const text = wrapper.find("div").text();
    btn.focus(() => {
      inp.focus()
    });
    // Crutches for the :focus style:
    inp.focus(() => {
      wrapper.addClass("focus");
    }).blur(() => {
      wrapper.removeClass("focus");
    });

    const file_api = !!((window.File && window.FileReader && window.FileList && window.Blob));

    inp.change(() => {
      let file_name;
      if (file_api && inp[0].files[0])
        file_name = inp[0].files[0].name;
      else
        file_name = inp.val().replace("C:\\fakepath\\", '');

      if (!file_name.length)
        return;

      if (lbl.is(":visible")) {
        lbl.text(file_name);
        btn.text("Выбрать");
      } else
        btn.text(file_name);


    }).change();
    $('.file_upload__remove').click(() => {
      $(".file_upload__input").val('');
      lbl.text(text);
    })
  });


  $(window).resize(() => {
    $(".file_upload input").triggerHandler("change");
  });

}


// WEBPACK FOOTER //
// app/scripts/components/inputFile.js